import { useEffect, useRef, useState } from 'react';
import { VehicleLocation } from '../types';

interface UseMockVehicleLocationOptions {
    intervalMs?: number;
    path?: [number, number][];
    vehicleId?: string;
}

const DEFAULT_PATH: [number, number][] = [
    [37.3349, -122.0090],
    [37.3355, -122.0105],
    [37.3362, -122.0085],
    [37.3350, -122.0070],
    [37.3344, -122.0082],
];

export function useMockVehicleLocation({ intervalMs = 5000, path = DEFAULT_PATH, vehicleId = 'MOCKVEH123' }: UseMockVehicleLocationOptions) {
    const [locations, setLocations] = useState<VehicleLocation[]>([]);
    const indexRef = useRef(0);

    useEffect(() => {
        const update = () => {
            const idx = indexRef.current % path.length;
            const [latitude, longitude] = path[idx];
            const loc: VehicleLocation = {
                vehicleId,
                latitude,
                longitude,
                timestamp: new Date().toISOString(),
                speed: 35 + Math.random() * 10,
                heading: Math.random() * 360,
                accuracy: 5 + Math.random() * 4,
            };
            setLocations(prev => [...prev, loc]);
            indexRef.current += 1;
        };
        update();
        const id = setInterval(update, intervalMs);
        return () => clearInterval(id);
    }, [intervalMs, path, vehicleId]);

    return { locations, latest: locations[locations.length - 1] };
}
